import ISection from '../models/IPackageUnit';
import AbstractCRUDService from './AbstractCRUDService';

class PackageUnitService extends AbstractCRUDService<ISection> {}

export default new PackageUnitService('logistics/package_unit');
